<div class="challenges_list">
    
    @if(this.challenges.length > 0){
        @for(challenge of this.challenges; track $index){
            @if(!this.maxItems || (this.showAll || $index < this.maxItems)){
                <app-challenge-item [challenge]="challenge" (onClickChallenge)="this.onClickChallenge($event)"/>
            }
        }

        @if(this.maxItems && !this.showAll && this.challenges.length > this.maxItems){
            <div class="challenges_list_btn_show_all" (click)="this.displayAll()">
                <ion-icon name="caret-down-outline"></ion-icon>
            </div>
        }
    }
    @else{
        <demooz-message type="info">{{'CHALLENGES_LIST.MSG_NO_CHALLENGE' | translate}}</demooz-message>
    }    
    
</div>

<demooz-modal #modalChallenge [heightAuto]="false" (onDidDismiss)="this.onDidDismissModalChallenge($event)">
    @if(this.challengeSelected){
        <app-challenge-response [challenge]="this.challengeSelected" (onSubmitResponse)="this.onSubmitChallengeResponse($event)"/>
    }
</demooz-modal>